import { useEffect } from "react";

export default function useContainerResize(
  containerElement: HTMLElement | null,
  callback = (containerWidth: number) => {}
) {
  useEffect(() => {
    function handleResize() {
      callback(containerElement?.clientWidth || 0);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
